module.exports = __webpack_public_path__ + "static/media/onboarding-4_3x.79c7c17d.png";